import { render, staticRenderFns } from "./ProductVariantDropdown.vue?vue&type=template&id=59c454f9&scoped=true"
import script from "./ProductVariantDropdown.vue?vue&type=script&lang=js"
export * from "./ProductVariantDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantDropdown.vue?vue&type=style&index=0&id=59c454f9&prod&lang=scss"
import style1 from "./ProductVariantDropdown.vue?vue&type=style&index=1&id=59c454f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c454f9",
  null
  
)

export default component.exports